export default {
  title: {
    en: 'Thank you for staying with us!',
  },

  text: {
    en: 'Your next {monthsCount, plural, one {bill} other {# bills}} will be {discountLabel} off',
  },
}
